import React, { Component } from 'react';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';


import StatusMessages from '../../../components/StatusMessages';


import { updateBranch, saveBranch } from '../../../actions/branches';


import SimpleReactValidator from 'simple-react-validator';

class BranchesForm extends Component{
    
    constructor(props){
        super(props);
        this.validator=new SimpleReactValidator();

        const { branch } = this.props;
        
        this.state = {
            branch: {
                ...branch
            },
            branch_updating: false,
            branch_creating: false,
            has_errors: false,

            errorMessageBranchUpdate: '',
            successBranchUpdate: ''
        };
    }

    componentWillReceiveProps(nextProps) {
        const { branches, branch } = nextProps;
            
        const { errorMessageBranchUpdate, successBranchUpdate } = branches;
        
        this.setState({
            branch: branch || {},
            updated_branch: {
                id: branch ? branch.id : ''
            },

            errorMessageBranchUpdate,
            successBranchUpdate
        });
    }

    handleSubmission = (e) => {
        e.preventDefault();

        const { updateBranch, saveBranch, user } = this.props;
        const { branch, updated_branch } = this.state;

        branch.insurer = user.userInfo.insurer;
        if(this.validator.allValid()){
            this.validator.hideMessages();
            if(branch.hasOwnProperty('id')){
                updateBranch(updated_branch);
            }
            else{
                saveBranch(this.state.branch);
            }
        } else{
            this.validator.showMessages();
            this.forceUpdate();
        }
       
    }


    onChange = (e) => {
        e.preventDefault();

        const { updated_branch, branch } = this.state;
        const { name, value } = e.target;

        this.setState({ 
            updated_branch: {
                ...updated_branch,
                [name]: value
            },
            branch: {
                ...branch,
                [name]: value
            },
        });
    }

    render(){
        
        const { branch, branch_updating, branch_creating  } = this.state;
        const { branches, edit } = this.props;
        
        return(
                <form 
                    className="form-horizontal"
                    noValidate
                    onSubmit={ this.handleSubmission }>


                {
                    branches.successBranchCreate && ! branch_creating ?
                        <StatusMessages 
                            type="success"
                            message={ branches.successMessage } />
                    :
                        null
                }

                    
                {
                    branches.errorMessageCreateBranch && ! branch_creating ?
                        <StatusMessages 
                            type="error"
                            message={ branches.errorMessageCreateBranch } />
                    :
                        null
                }

                    {
                    branches.errorMessageBranchUpdate && edit && ! branch_updating ?
                        <StatusMessages
                            type="error"
                            message={ branches.errorMessageBranchUpdate } />
                    :
                        null
                }
                {
                    branches.successBranchForm && edit && ! branch_updating ?
                            <StatusMessages 
                                type="success" 
                                message={ branches.successMessage } />
                    : null
                }
                    

                    <div className="form-group">
                        <label className="col-sm-4 control-label">Branch Name: <span className="text-danger">*</span></label>
                        <div className="col-sm-8">
                            <input 
                                className="form-control" 
                                type="text" 
                                value= { branch.branch_name || ''}
                                name="branch_name" 
                                required
                                onChange={ this.onChange }/>
                            {this.validator.message('branch_name',branch.branch_name, 'required', 'text-danger')}  
                        </div>
                    </div>

                    <div className="form-group">
                         <label className="col-sm-4 control-label">Branch Code: <span className="text-danger">*</span></label>
                         <div className="col-sm-8">
                            <input 
                                className="form-control" 
                                type="text" 
                                value= { branch.branch_code || ''}
                                name="branch_code" 
                                required
                                onChange={ this.onChange }/>
                            {this.validator.message('branch_code', branch.branch_code,'required','text-danger')}
                        </div>
                    </div>

                    <div className="form-group">
                         <label className="col-sm-4 control-label">Branch Region: <span className="text-danger">*</span></label>
                         <div className="col-sm-8">
                            <select 
                                    name="branch_region" 
                                    className="form-control"
                                    required={ !edit }
                                    onChange={ this.onChange }>

                                    <option value="">Select Region </option>

                                {
                                    branches.regions.map( region =>
                                        <option key={region.id} value={ region.id }>{ region.name}</option>
                                    )
                                }
                               
                            </select>
                        </div>
                    </div>

                    <div className="form-group">
                         <label className="col-sm-4 control-label">Location: <span className="text-danger">*</span></label>
                         <div className="col-sm-8">
                            <input 
                                className="form-control" 
                                type="text" 
                                value= { branch.branch_location || ''}
                                name="branch_location" 
                                required 
                                onChange={ this.onChange }/>
                            {this.validator.message('branch_location', branch.branch_location,'required','text-danger')}
                        </div>
                    </div>

                    <div className="form-group">
                         <label className="col-sm-4 control-label">Email Address: <span className="text-danger">*</span></label>
                         <div className="col-sm-8">
                            <input 
                                className="form-control" 
                                type="email" 
                                value= { branch.email || ''}
                                name="email" 
                                required 
                                onChange={ this.onChange }/>
                                {this.validator.message('email', branch.email,'required','text-danger')}
                        </div>
                    </div>

                    <div className="form-group">
                         <label className="col-sm-4 control-label">Phone: <span className="text-danger">*</span></label>
                         <div className="col-sm-8">
                            <input 
                                className="form-control" 
                                type="text" 
                                value= { branch.phone || ''}
                                name="phone" 
                                required 
                                onChange={ this.onChange }/>
                            {this.validator.message('phone', branch.phone,'required','text-danger')}
                        </div>
                    </div>

                    
                    
                    <div className="col-sm-offset-4">
                        <div className="col-sm-12">
                        {
                            branch.hasOwnProperty('id') ?
                                <button className="btn btn-warning" >
                                    <i className="icon ion-edit"></i>&nbsp; Update
                                </button>
                            :
                                <button className="btn btn-success">
                                    <i className="icon ion-checkmark"></i>&nbsp; Create
                                </button>
                        }
                        </div>
                    </div>
                </form>
           
        );
    }
}

const mapStateToProps = (state, ownProps) => ({
    user: state.user,
    branches: state.branches
});

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({ updateBranch, saveBranch }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(BranchesForm);



// WEBPACK FOOTER //
// ./src/pages/dashboard/agents/BranchesForm.jsx